import { quoteFields, riskProfileFields } from "kw/api/fragments";

import { $ } from "kw/api";
import { useAPI } from "kw/api/useAPI";

export const useToggleEnabledProducts = (riskProfileId, priceRiskProfile) => {
  const { mutation, loading } = useAPI();
  const toggleEnabledProducts = (productKey, enabled) => {
    mutation(
      toggleEnabledProductsMutation,
      () => {
        priceRiskProfile();
      },
      { input: { riskProfileId, productKey, enabled } }
    );
  };
  return { toggleEnabledProducts, loading };
};

const toggleEnabledProductsMutation = {
  toggleEnabledProducts: [
    {
      input: $("input", "ToggleEnabledProductsInput!"),
    },
    {
      ...riskProfileFields,
      quotes: {
        ...quoteFields,
      },
    },
  ],
};
